import axios from 'src/config/axios'

export const getUser = (email) => axios.get('/users', { params: { email } })

export const deleteUser = (userId) =>
  axios.delete('/users', { params: { userId } })
